module.exports = __webpack_public_path__ + "img/follow_1.ac367958.png";